export default __webpack_public_path__ + "static/media/dp-ia-java.131e52ac.png";